import { render, staticRenderFns } from "./phoneAuth.vue?vue&type=template&id=5f8d27cb&scoped=true&"
import script from "./phoneAuth.vue?vue&type=script&lang=js&"
export * from "./phoneAuth.vue?vue&type=script&lang=js&"
import style0 from "./phoneAuth.vue?vue&type=style&index=0&id=5f8d27cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8d27cb",
  null
  
)

export default component.exports